import React,{useState} from 'react'
import {getAllUrlParams,setLocalStorage,getLocalStorage} from "../../utils/utils"
import settings from '../../settings.json'

import axios from 'axios'

export default function Login() {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)

    function login(event){
        event.preventDefault()
        setLoading(true);

        let data={
            "username":username,
            "password":password
        }
        axios.post(settings.url_api+"/auth/login/",data).then((res)=>{
            try {
                setLocalStorage("tk",res.data.token)
                setLocalStorage("first_name",res.data.user.first_name)
                setLocalStorage("last_name",res.data.user.last_name)
                setLocalStorage("username",res.data.user.username)
                setLocalStorage("time", Date())
                window.location.href=getAllUrlParams().to
            } catch (error) {
                window.location.href="/shop";
            }
        }).catch((error)=>{
            setLoading(false)
        })
    }

    return(
    <div className="simple-login-container">
        <h2>Login</h2>
        <form onSubmit={(e)=>login(e)}>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="text" className="form-control" placeholder="Username" onChange={(e)=>setUsername(e.target.value)} value={username}/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="password" placeholder="Enter your Password" onChange={(e)=>setPassword(e.target.value)} value={password} className="form-control"/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input disabled={loading} type="submit" className="btn btn-block btn-login" value="Login" />
            </div>
        </div>
        </form>
        <div style={{textAling:"center"}}>
            or 
            <div className="row">
                <div className="col-md-12 form-group">
                    <a href="/register">
                        <input type="submit" className="btn btn-block btn-login" value="Sing-up"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
    )
}